module.exports = __webpack_public_path__ + "img/com.aeg.myaeg.9abc48db.webp";